import React from 'react';
//import './erro.css';
import {Link} from 'react-router-dom';

import img_err from '../../images/svg/erro_comunicacao.svg';

import { useNavigate } from 'react-router-dom';

export default function ErroComunicacao() {

  const navigate = useNavigate();
  return (
    
    <section>
        <div className="container erro">
          <div className="row">
              
               <div className="col-12 col-md-6">
                  <img src={img_err} className="img-fluid"></img>
              </div>
           
              <div className="col-12 col-md-6">
              <h1 className="d-none d-md-block">Ocorreu um erro na ligação</h1>
                               
                    <h3>Verifique a sua ligação à Internet</h3>                  
                  
                {/*<Link className="btn btn-erro" to="/">Voltar</Link> */}
                <button className="btn btn-erro" onClick={() => navigate(-1)}>Voltar</button>
                  
              </div>
            </div>
          </div>
        
      </section>
    );
}